import React, { useEffect, useState } from "react";
import { Card, Button, Pagination, CircularProgress } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import { useHistory } from "react-router-dom";
import { useGetAllClassicLevelsQuery } from "lib/store/service/classic";
import { getTableData } from "./data/tableData";
import { Add } from "@mui/icons-material";

function ClassicLevels() {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });

  const { data, isLoading, isFetching, refetch } = useGetAllClassicLevelsQuery({
    page,
    limit,
  });

  const rawLevels = data?.response?.data?.levels || data?.data?.levels || data?.data || [];
  const totalPages = data?.response?.data?.totalPages || data?.data?.totalPages || Math.ceil(rawLevels.length / 10) || 1;

  useEffect(() => {
    setTableData(getTableData(data || {}, refetch));
  }, [data, refetch]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Card>
            <VuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <VuiTypography variant="h5" color="white" fontWeight="bold">
                Official Classic Campaign Levels
              </VuiTypography>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => history.push("/classic/create")}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  backgroundColor: "#06b6d4 !important",
                  color: "#ffffff !important",
                  borderRadius: "10px",
                  px: 3,
                  py: 1,
                  boxShadow: "0 0 14px rgba(6, 182, 212, 0.4)",
                  "&:hover": {
                    backgroundColor: "#0891b2 !important",
                    boxShadow: "0 0 20px rgba(6, 182, 212, 0.7)",
                  },
                }}
              >
                Create Classic Level
              </Button>
            </VuiBox>

            <VuiBox p={2} sx={{ minHeight: "50vh" }}>
              {isLoading || isFetching ? (
                <VuiBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={8} gap={2}>
                  <CircularProgress color="info" size={40} />
                  <VuiTypography variant="button" color="text" fontWeight="bold">
                    Loading Classic Campaign Levels...
                  </VuiTypography>
                </VuiBox>
              ) : tableData.rows?.length === 0 ? (
                <VuiBox display="flex" justifyContent="center" alignItems="center" py={8}>
                  <VuiTypography variant="button" color="text">
                    No Classic Levels found. Click "Create Classic Level" to add one!
                  </VuiTypography>
                </VuiBox>
              ) : (
                <Table columns={tableData.columns} rows={tableData.rows} />
              )}
            </VuiBox>
          </Card>

          <Card sx={{ mt: 2, p: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              variant="outlined"
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#ffffff !important",
                  borderColor: "#334155",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#06b6d4 !important",
                  color: "#ffffff !important",
                  borderColor: "#06b6d4",
                  fontWeight: "bold",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "rgba(6, 182, 212, 0.2)",
                },
              }}
            />
          </Card>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ClassicLevels;
